import { Injectable, computed, signal } from '@angular/core';

const PLAYER_TOKEN_KEY = 'ecl_vault_player_token';
const PLAYER_IDENTITY_KEY = 'ecl_vault_player_identity';

export interface PlayerIdentity {
  id: number;
  pseudo: string;
  email?: string;
}

@Injectable({ providedIn: 'root' })
export class SessionService {
  private readonly tokenSignal = signal<string | null>(this.readStoredToken());
  private readonly identitySignal = signal<PlayerIdentity | null>(this.readStoredIdentity());

  readonly token = this.tokenSignal.asReadonly();
  readonly isAuthenticated = computed(() => !!this.tokenSignal());
  readonly identity = this.identitySignal.asReadonly();

  setToken(token: string): void {
    localStorage.setItem(PLAYER_TOKEN_KEY, token);
    this.tokenSignal.set(token);
  }

  setIdentity(identity: PlayerIdentity): void {
    localStorage.setItem(PLAYER_IDENTITY_KEY, JSON.stringify(identity));
    this.identitySignal.set(identity);
  }

  clearToken(): void {
    localStorage.removeItem(PLAYER_TOKEN_KEY);
    localStorage.removeItem(PLAYER_IDENTITY_KEY);
    this.tokenSignal.set(null);
    this.identitySignal.set(null);
  }

  private readStoredToken(): string | null {
    return localStorage.getItem(PLAYER_TOKEN_KEY);
  }

  private readStoredIdentity(): PlayerIdentity | null {
    const raw = localStorage.getItem(PLAYER_IDENTITY_KEY);
    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw) as PlayerIdentity;
      if (typeof parsed?.id !== 'number' || typeof parsed?.pseudo !== 'string') {
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  }
}
